import axios from 'axios'
const API_URL = process.env.GATSBY_GIFTING_FLOW_API_URL || ''
const baseURL = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL

export const getGift = async slug => {
  try {
    const response = await axios.get(`${baseURL}/gift/${slug}`)

    return response.data
  } catch (error) {
    console.error('Axios Error:', error)

    return error.response
  }
}
